/* eslint-disable react/jsx-key */

import React from 'react';
import { createIcon } from '@chakra-ui/icons';

export const SuccessfullyIcon = createIcon({
  displayName: 'SuccessfullyIcon',
  viewBox: '0 0 160 109',
  path: [
    <svg
      width="160"
      height="109"
      viewBox="0 0 160 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="84.4694"
        cy="102.444"
        rx="34.8171"
        ry="6.55639"
        fill="#C2DBF2"
        fillOpacity="0.5"
      />
      <path
        d="M84.4694 33.822L87.0477 38.5227C87.3786 39.126 88.2057 39.2227 88.6668 38.7119L92.2591 34.7328L93.6843 39.9019C93.8671 40.5651 94.6496 40.8499 95.216 40.4593L99.6288 37.4162L99.824 42.7749C99.849 43.4624 100.545 43.9199 101.186 43.6705L106.181 41.7274L105.136 46.9871C105.002 47.6618 105.573 48.2672 106.254 48.1725L111.563 47.4343L109.334 52.3111C109.048 52.9366 109.464 53.6574 110.149 53.7224L115.485 54.2289L112.191 58.46C111.768 59.0026 112.007 59.8 112.658 60.0212L117.734 61.7452L113.554 65.1022C113.017 65.5328 113.066 66.3637 113.648 66.7291L118.19 69.5779L113.349 71.8798C112.728 72.1751 112.583 72.9947 113.066 73.4847L116.828 77.3046L111.587 78.4274C110.914 78.5715 110.585 79.3357 110.941 79.9238L113.722 84.5088L108.363 84.3921C107.675 84.3771 107.178 85.0448 107.39 85.6993L109.039 90.8021L103.851 89.4523C103.185 89.279 102.548 89.8141 102.603 90.4998L103.031 95.8452L98.2944 93.3351C97.6865 93.0129 96.9424 93.3866 96.8378 94.0666L96.0221 99.3663L91.9923 95.8313C91.475 95.3776 90.6647 95.5696 90.4061 96.2072L88.3908 101.176L85.2845 96.8062C84.8858 96.2454 84.0531 96.2454 83.6544 96.8062L80.5481 101.176L78.5328 96.2072C78.2741 95.5696 77.4639 95.3776 76.9466 95.8313L72.9168 99.3663L72.1011 94.0666C71.9965 93.3866 71.2524 93.0129 70.6445 93.3351L65.9083 95.8452L66.3363 90.4998C66.3912 89.8141 65.7534 89.279 65.0877 89.4523L59.9004 90.8021L61.5492 85.6993C61.7607 85.0448 61.2635 84.3771 60.5758 84.3921L55.2169 84.5088L57.9977 79.9238C58.3544 79.3357 58.0246 78.5715 57.3521 78.4274L52.1105 77.3046L55.8733 73.4847C56.3559 72.9947 56.2114 72.1751 55.5903 71.8798L50.7486 69.5779L55.2905 66.7291C55.8731 66.3637 55.9215 65.5328 55.3852 65.1022L51.2046 61.7452L56.2806 60.0212C56.9318 59.8 57.1706 59.0026 56.7481 58.46L53.454 54.2289L58.7904 53.7224C59.4751 53.6574 59.8913 52.9366 59.6053 52.3111L57.3754 47.4343L62.6845 48.1725C63.3658 48.2672 63.9371 47.6617 63.803 46.9871L62.7575 41.7274L67.753 43.6705C68.3942 43.9199 69.0898 43.4624 69.1149 42.775L69.3101 37.4162L73.7229 40.4593C74.2893 40.8499 75.0717 40.5651 75.2546 39.9019L76.6798 34.7328L80.2721 38.7119C80.7332 39.2227 81.5603 39.126 81.8912 38.5227L84.4694 33.822Z"
        fill="#C2DBF2"
        stroke="#1962A6"
      />
      <path
        d="M78.3785 76.1623L78.7321 76.516L79.0857 76.1623L99.3616 55.8784L99.3637 55.8763C99.5047 55.7336 99.6725 55.6203 99.8575 55.5429C100.043 55.4656 100.241 55.4258 100.442 55.4258C100.642 55.4258 100.841 55.4656 101.026 55.5429C101.211 55.6203 101.379 55.7336 101.519 55.8763L101.519 55.8763L101.524 55.8806C101.666 56.0216 101.78 56.1895 101.857 56.3747L102.318 56.182L101.857 56.3747C101.934 56.5598 101.974 56.7585 101.974 56.9592C101.974 57.1598 101.934 57.3585 101.857 57.5437L102.318 57.7363L101.857 57.5437C101.78 57.7288 101.666 57.8967 101.524 58.0377L101.522 58.0397L79.8123 79.7373L79.8121 79.7374C79.2087 80.3412 78.2351 80.3412 77.6316 79.7374L69.0502 71.1527L69.0481 71.1505C68.9054 71.0095 68.7921 70.8416 68.7148 70.6564C68.6375 70.4713 68.5977 70.2726 68.5977 70.0719C68.5977 69.8713 68.6375 69.6726 68.7148 69.4875C68.7921 69.3023 68.9054 69.1344 69.0481 68.9934L69.0481 68.9934L69.0524 68.9891C69.1933 68.8463 69.3612 68.733 69.5462 68.6557C69.7312 68.5784 69.9297 68.5386 70.1302 68.5386C70.3307 68.5386 70.5293 68.5784 70.7143 68.6557C70.8993 68.733 71.0672 68.8463 71.2081 68.9891L71.2081 68.9891L71.2103 68.9912L78.3785 76.1623Z"
        fill="#0269CA"
        stroke="#0269CA"
      />
      <rect
        width="3.27718"
        height="3.27792"
        transform="matrix(0.887099 0.461579 -0.461293 0.887248 2.01172 39.3379)"
        fill="#8F00FF"
      />
      <rect
        width="3.27733"
        height="3.27777"
        transform="matrix(0.817485 -0.57595 0.575646 0.817699 57.0273 1.8877)"
        fill="#0269CA"
      />
      <rect
        width="6.55403"
        height="6.55616"
        transform="matrix(0.95519 -0.295992 0.295779 0.955256 150.418 19.9697)"
        fill="#EBD1FF"
      />
      <path
        d="M46.3756 23.7666L46.9274 25.4655H48.713L47.2685 26.5155L47.8202 28.2143L46.3756 27.1644L44.9311 28.2143L45.4828 26.5155L44.0383 25.4655H45.8239L46.3756 23.7666Z"
        fill="#C2DBF2"
      />
      <path
        d="M26.2185 51.8815L26.1749 54.2629L28.4253 55.0403L26.1479 55.7346L26.1043 58.116L24.7404 56.1638L22.463 56.8581L23.8975 54.9572L22.5336 53.005L24.784 53.7824L26.2185 51.8815Z"
        fill="#FFC793"
      />
      <path
        d="M157.951 55.4452L157.929 56.6358L159.054 57.0245L157.916 57.3717L157.894 58.5624L157.212 57.5863L156.073 57.9335L156.791 56.983L156.109 56.0069L157.234 56.3956L157.951 55.4452Z"
        fill="#70A0CC"
      />
      <path d="M85.1052 26.7991L85.5745 29.599L82.916 28.6056L85.1052 26.7991Z" fill="#B350FF" />
      <path d="M99.2684 9.68172L104.026 12.7775L98.9675 15.3517L99.2684 9.68172Z" fill="#1962A6" />
      <path d="M134.855 69.6621L137.693 74.5794H132.017L134.855 69.6621Z" fill="#FFE7D1" />
      <ellipse cx="134.853" cy="42.6166" rx="1.63845" ry="1.6391" fill="#1962A6" />
      <ellipse cx="12.7886" cy="81.955" rx="3.2769" ry="3.27819" fill="#B898D9" />
    </svg>,
  ],
});
